import { FC } from 'react'
import {
  Typography,
  Checkbox,
  CircularProgress,
  IconButton,
} from '@mui/material'

import { TRepProps } from './Rep.types'
import './Rep.scss'
import { useRepLogic } from './Rep.logic'
import { Delete } from '@mui/icons-material'
import classNames from 'classnames'

export const Rep: FC<TRepProps> = (props) => {
  const { rep, isLoading, onDelete } = props

  const logic = useRepLogic(props)

  return (
    <div className="special-request-rep-item-container">
      <div className="details-container">
        <div className="name-email-wrapper">
          <Typography variant="h4">
            {rep.lastName}, {rep.firstName}
          </Typography>
          <Typography variant="h5">{rep.email}</Typography>
        </div>
        <IconButton onClick={() => onDelete(rep)}>
          <Delete color="primary" />
        </IconButton>
      </div>
      <div
        className={classNames('actions', {
          'is-loading': isLoading,
        })}
      >
        {isLoading ? (
          <CircularProgress size={23} />
        ) : (
          <>
            <div className="notification-checkbox">
              <Checkbox
                checked={rep.notifyEmail}
                onChange={(e) =>
                  logic.handleCheckboxChange('notifyEmail', e.target.checked)
                }
                color="primary"
              />
              <Typography variant="body2">Email</Typography>
            </div>
            <div className="notification-checkbox">
              <Checkbox
                checked={rep.notifySms}
                onChange={(e) =>
                  logic.handleCheckboxChange('notifySms', e.target.checked)
                }
                color="primary"
              />
              <Typography variant="body2">SMS</Typography>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
